/* eslint-disable no-param-reassign */
import { MutationTree } from 'vuex';
import { 
    AjaxReporter,
    ReporterFactory,
    ScriptReporter,
    IReportingEvent,
    ITrackingServerConfig,
    TrackingServerType } from '@andromeda/telemetry-data-access-orion';
import { Dictionary } from 'lodash';
import {
    SET_TRACKING_CONFIGS,
    UPDATE_BASE_REPORTING_PARAMS,
    SEND_REPORT,
} from '../types';
import { ITrackingState } from './state';

export const mutations: MutationTree<ITrackingState> = {
    [SET_TRACKING_CONFIGS]: (state: ITrackingState, configs: ITrackingServerConfig[]) => {
        // console.log('TODO: seperate tracking store');
        state.trackingConfigs = configs;

        state.reporters = configs.map((config) => {
            if (config.type === TrackingServerType.SCRIPT) {
                return ReporterFactory.Create(ScriptReporter, config);
            }
            return ReporterFactory.Create(AjaxReporter, config);
        });
    },
    [UPDATE_BASE_REPORTING_PARAMS]: (state: ITrackingState, params: Dictionary<string | number | boolean | object | Array<string | number | boolean>> | undefined) => {
        // eslint-disable-next-line no-param-reassign
        state.trackingConfigs.forEach((trackingCFG) => { trackingCFG.baseParams = { ...trackingCFG.baseParams, ...params }; });
    },
    [SEND_REPORT]: (state: ITrackingState, event: IReportingEvent) => {
        state.reportQueue.push(event);
    },
};
